import {
  getUniversalTableLiteColumnCellProps,
  getUniversalTableLiteColumnMinWidthPx
} from "./universalTableLiteColumnMinWidths";

export function getStackedPairCellProps(first, second) {
  const props = getUniversalTableLiteColumnCellProps(first);
  if (!second) {
    return props;
  }

  const minWidth = Math.max(
    props.style.minWidth,
    getUniversalTableLiteColumnMinWidthPx(second)
  );

  return {
    ...props,
    style: {
      ...props.style,
      flexBasis: minWidth,
      minWidth
    }
  };
}
